import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ShortNumberPipe } from '../../../ui/pipes/short-number.pipe';
import {
  TuiAppearance,
  TuiButton,
  TuiError,
  TuiLabel,
  TuiTextfield,
  TuiTextfieldComponent,
  TuiTextfieldDirective,
  TuiTextfieldDropdownDirective,
  TuiTextfieldMultiComponent
} from '@taiga-ui/core';
import {
  TuiButtonLoading,
  TuiChevron,
  TuiComboBox,
  TuiDataListWrapperComponent,
  TuiFilterByInputPipe,
  TuiInputChipComponent,
  TuiInputChipDirective,
  TuiMultiSelectGroupDirective, TuiSelect,
  TuiTextarea
} from '@taiga-ui/kit';
import { TuiForm } from '@taiga-ui/layout';
import { Audience } from './audience-form.model';
import { Sector, Segment } from '../../../core/sector/sector.model';
import { TuiStringMatcher } from '@taiga-ui/cdk';

@Component({
  selector: 'app-audience-form',
  imports: [
    ReactiveFormsModule,
    ShortNumberPipe,
    TuiAppearance,
    TuiButton,
    TuiButtonLoading,
    TuiChevron,
    TuiComboBox,
    TuiDataListWrapperComponent,
    TuiError,
    TuiFilterByInputPipe,
    TuiForm,
    TuiInputChipComponent,
    TuiInputChipDirective,
    TuiLabel,
    TuiMultiSelectGroupDirective,
    TuiTextarea,
    TuiTextfieldComponent,
    TuiTextfieldDirective,
    TuiTextfieldDropdownDirective,
    TuiTextfieldMultiComponent,
    TuiTextfield,
    TuiSelect
  ],
  templateUrl: './audience-form.html',
  styleUrl: './audience-form.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ShortNumberPipe]
})
export class AudienceForm {
  readonly form = input.required<FormGroup<Audience>>();
  readonly sectors = input<Sector[] | null>(null);
  readonly segments = input<Segment[] | null>(null);
  readonly platforms = input<string[] | null>(null);
  readonly isLoading = input<boolean>(false);

  readonly buildAudience = output<void>();
  readonly openSegmentModal = output<void>();

  readonly #shortNumberPipe = inject(ShortNumberPipe);

  constructor() {
    effect(() => {
      const value = this.sectors()?.[0];

      if (value) {
        this.form().controls.sector.setValue(value);
      }
    });
  }

  /* Sector */
  protected sectorStringify = (item: Sector) => item.name;
  protected readonly sectorMatcher: TuiStringMatcher<Sector> = (item, query) => {
    return item.name.toLowerCase().includes(query.toLowerCase());
  };
  /* Sector */

  /* Segment */
  protected readonly segmentMatcher: TuiStringMatcher<Segment> = (item, query) => {
    return item.name.toLowerCase().includes(query.toLowerCase());
  };
  protected readonly segmentIdentityMatcher = (a: Segment, b: Segment) => a.id === b.id;

  protected stringifySegment = (item: Segment) =>
    `${item.name}: ${this.#shortNumberPipe.transform(item.reach)}`;

  protected isSegmentDropdownItemDisabled = (search: Segment | string) => {
    return typeof search === 'string';
  };
  /* Segment */
}
